var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoKreativaRgb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 359.4 91.9",
    style: {
      enableBackground: "new 0 0 359.4 91.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#363A8B;}\n\t.st1{fill:#E0457B;}\n\t.st2{fill:#F6B331;}\n\t.st3{fill:#201547;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "9.4,0 39.4,0 59.4,36 30.3,36  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "59.4,36 30.3,36 45.1,61.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "30.3,36 45.1,61.7 28.6,91.9 0,91.9  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M109.1,77.2H96.8L81.6,58.7l-0.1,18.4h-9.7L72,14.5h9.7l-0.1,35l11.3-12.9h12.6l-16,17.7L109.1,77.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M134.5,45.4c-0.7-0.1-1.4-0.2-1.9-0.2c-6.4,0-9.9,6.6-9.9,17.9l-0.1,14.2h-9.8l0.1-40.6h9.7v8.7 c2.1-6.8,6.4-9.7,11.3-9.7c2.3,0,4.9,0.5,6.4,1.4"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M178.8,58.4l-30.3,3.2c1.6,5.5,6.1,8.1,12,7.5c4.2-0.4,8.1-2.8,10-6.3l7,4.4c-3,6.3-9.6,10.3-16.8,11.1 c-11.6,1.2-21.4-6.5-22.6-19.2c-1.3-13,7.2-22.3,18.4-23.5c11.1-1.2,20.7,6.1,22,18.8C178.7,55.6,178.7,56.9,178.8,58.4z  M168.6,52.6c-1.1-5.5-5.6-8.4-11.1-7.8c-5.2,0.6-9.2,3.7-9.8,10L168.6,52.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M214.8,37.1h9.7l-0.1,40.6h-9.7v-6.3c-2.6,4.4-7.8,7.4-13.4,7.3c-10.5,0-18.8-8.8-18.8-21.4 c0-12.3,8.1-21.3,19.2-21.2c5.4,0,10.5,2.5,13.1,6.7V37.1z M214.6,57.3c0-7-5.5-11.9-11.3-11.9c-6.3,0-11.1,5.3-11.1,11.9 s4.7,12,11.1,12C209.3,69.3,214.5,64.1,214.6,57.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M255.5,37.2v8h-8.3l-0.1,32.6h-9.7l0.1-32.6h-7v-8h7l0.1-14.9h9.7l-0.1,14.9L255.5,37.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M260.2,22.9c0-3.6,3-6.2,6.4-6.1c3.5,0,6.3,2.6,6.3,6.2c0,3.5-2.8,6.2-6.3,6.1 C263.1,29.1,260.2,26.4,260.2,22.9z M261.5,77.8l0.1-40.6h9.7l-0.1,40.6H261.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M307.6,37.4h10.5L301.5,78h-8.9l-16.2-40.6h10.5l10.3,27.8L307.6,37.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M349.6,37.6h9.7l-0.1,40.6h-9.7v-6.3c-2.6,4.4-7.8,7.4-13.4,7.3c-10.5,0-18.8-8.8-18.8-21.4 c0-12.3,8.1-21.3,19.2-21.2c5.4,0,10.5,2.5,13.1,6.7L349.6,37.6z M349.4,57.8c0-7-5.5-11.9-11.3-11.9c-6.3,0-11.1,5.3-11.1,11.9 c0,6.5,4.7,12,11.1,12C344.2,69.8,349.4,64.6,349.4,57.8z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoKreativaRgb);
export default __webpack_public_path__ + "static/media/logo_kreativa_RGB.8ca47b82cfe15c15260d60d8becd17b8.svg";
export { ForwardRef as ReactComponent };